import { Box, useTheme, type BoxProps } from '@mui/material';
import Color from 'color';
import React from 'react';

interface RatingOptionsHeaderOwnProps {
  readonly children: React.ReactNode;
  /** Vertical padding of the row. */
  readonly paddingY?: string;
  readonly minHeight?: string;
  readonly fontSize?: string;
  readonly fontWeight?: number | string;
}

const RatingOptionsHeader = ({
  children,
  paddingY = '0.75rem',
  minHeight = '4rem',
  fontSize = '1.1rem',
  fontWeight = 'bold',
  ...props
}: RatingOptionsHeaderOwnProps &
  Omit<BoxProps, 'fontSize' | 'fontWeight' | 'minHeight'>) => {
  const { palette } = useTheme();
  return (
    <Box
      display="flex"
      style={{
        minHeight,
        display: 'flex',
        alignItems: 'center',
        padding: `${paddingY} 0.5rem`,
        paddingLeft: '1.25rem',
        borderRadius: '4px 4px 0 0',
        backgroundColor: Color(palette.background.default)
          .lighten(palette.mode === 'dark' ? 0.25 : 0.02)
          .toString(),
      }}
      {...props}
    >
      <Box
        style={{
          fontSize,
          fontWeight,
          width: '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default RatingOptionsHeader;
